import { RouterProvider } from 'react-router-dom';

import { AppProviders } from './providers/AppProviders';
import { createAppRouter } from '@/router/router';

/**
 * The app: providers, then the router.
 *
 * The router is created once at module scope rather than inside the component.
 * `createBrowserRouter` subscribes to history; building a second one on a re-render
 * would leave two subscribers racing to handle the same navigation.
 *
 * Providers sit *outside* `RouterProvider` because `AuthProvider` starts the session
 * restore on mount, and a route guard that renders before the restore has finished
 * has to be able to read `status === 'restoring'` from a provider that already
 * exists.
 */

const router = createAppRouter();

export function App() {
  return (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  );
}
